module.exports = __webpack_public_path__ + "img/bonus_symbol.d45d5edc.png";